<template>
  <div>
    <NavBar />
    <NewImporter @created="getImporters()" />
    <ViewImporter :importer_id="importer_id" @updated="getImporters()" />
    <b-container class="elevation-2 rounded">
      <b-row>
        <b-col cols="auto">
          <h4>Importadores</h4>
        </b-col>
        <b-col>
          <b-checkbox
            v-model="show_inactive"
            switch
            inline
            size="lg"
            @input="getImporters()"
          >
            Mostrar inativos
          </b-checkbox>
        </b-col>
        <b-col cols="auto">
          <v-btn class="v-primary" v-b-modal.new_importer>
            <span class="fa fa-plus"></span>NOVO
          </v-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-text-field
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-data-table
            :headers="headers"
            :items="importers"
            dense
            @click:row="openViewModal"
          >
            <template v-slot:[`item.status`]="{ item }">
              {{ item.status ? "ATIVO" : "INATIVO" }}
            </template>
          </v-data-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import NewImporter from "../templates/Importer/NewImporter";
import ViewImporter from "../templates/Importer/ViewImporter";
import api from "../services/api";

export default {
  name: "Importers",
  components: {
    NavBar,
    NewImporter,
    ViewImporter,
  },
  data() {
    return {
      errors: [],
      loading: false,

      show_inactive: false,
      headers: [
        { text: "Nome", value: "name" },
        { text: "Tabela", value: "table_name" },
        { text: "Status", value: "status" },
      ],
      importers: [],

      importer_id: "",
    };
  },
  created() {
    this.getImporters();
  },
  methods: {
    async getImporters() {
      try {
        this.loading = true;

        let params = { show_inactive: this.show_inactive };
        let response = await api.get("/importers", { params });
        let { error, errors, importers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.importers = importers;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async openViewModal(item) {
      this.importer_id = item.id;
      this.$bvModal.show("view_importer");
    },
  },
};
</script>

<style>
</style>